// Put your application javascript here

const allowedGifts = [

  {
    enabled: false,
    handle: "prolon-signature-bottle-10-off",
    description:"Auto Add Signature Bottle for order above $150",
    variant_id: 39896756092974,
    quantity_to_add: 1,
    conditions: { 
 
      cart_total: {
        operator: ">=",
        value: 150,
      }, 
      cart_items: {
        operator: ">=",
        value: 1,
      },
      
    },
  },
  {  
    enabled: false,
    handle: "free-10ct-fast-bar-new", 
    description:"Auto Add Fast Bar 10 ct for order above $100",
    variant_id: 40022573645870,  
    quantity_to_add: 1, 
    conditions: {  

      cart_total: {
        operator: ">=",
        value: 100,
      }      
    },
  }, 
];   

const store = Vue.reactive({
  state: {
    cartState: [],
    updatingCart: false,
    recommendedCollection: [],
    allowedGifts: allowedGifts.filter((gift) => gift.enabled),
    upsell_in_cart: false,
  },

  getCart() {
    axios
      .get("/cart.js")
      .then((response) => {
        this.state.cartState.unshift(response.data);
        this.state.updatingCart = false;
        this.state.cartState.length = 1;
        this.checkCart();
      })
      .catch((error) => {
        console.log(error);
      });
  }, 
  async getShopifyCart() {
    return new Promise(resolve=>{

      axios
      .get("/cart?view=slidecart")
      .then((response) => {

      resolve(response.data);
      })
      .catch((error) => {
        resolve(null); 
        console.log(error);
      });
    });
  },  
  setCartLoading() {
    this.state.updatingCart = true;
  }, 
  getRecommendedCollection() {
    axios
      .get("/collections/checkout-upsell/products.json")
      .then((response) => {
        if (response.data && response.data.products) {
          this.state.recommendedCollection = response.data.products;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
  addToCart(id, quantity, selling_plan, cb) {
    store.setCartLoading();
    axios
      .post("/cart/add.js", {
        id: id,
        quantity: quantity,
        selling_plan: selling_plan,
      })
      .then((response) => {
        store.getCart();
        toggleCart.showCart();

        if (cb) cb(response);
      })
      .catch((error) => {
        console.log(error);
        if(error && error.response && error.response.data && error.response.data.description){
          alert(error.response.data.description);
        } 
        if (cb) cb(error);
      });
  },
  addToCartWithProperties({ id, quantity, selling_plan, cb, properties }) {
    store.setCartLoading();
    axios
      .post("/cart/add.js", {
        items: [
          {
            id: id,
            quantity: quantity,
            selling_plan: selling_plan,
            properties,
          },
        ],
      }) 
      .then((response) => {
        store.getCart();
        toggleCart.showCart();
        if (cb) cb(response);
      })
      .catch((error) => {
        console.log(error);
        if(error && error.response && error.response.data && error.response.data.description){
          alert(error.response.data.description);
        } 
        if (cb) cb(error);
      });
  },
  async bulkAddToCart(items, cb) {
    store.setCartLoading();
    await axios.post("/cart/clear.js");
    axios
      .post("/cart/add.js", {
        items: items,
      })
      .then((response) => {
        store.getCart();
        //   toggleCart.showCart();
        if (cb) cb(response);
      })
      .catch((error) => {
        console.log(error);
        if(error && error.response && error.response.data && error.response.data.description){
          alert(error.response.data.description);
        }  
        if (cb) cb(error);
      });
  },
  async bulktUpdateCart(items, cb) {
    store.setCartLoading();
    axios
      .post("/cart/update.js", {
        updates: items,
      })
      .then((response) => {
        store.getCart();
        if (cb) cb(response);
      })
      .catch((error) => {
        console.log(error);
        if(error && error.response && error.response.data && error.response.data.description){
          alert(error.response.data.description);
        } 
        if (cb) cb(error);
      });
  },
  async checkRecommendedUpsells(cart) {
    if (cart) {
      totalRecommendationProductsinCart = 0;
      cart.items.forEach((item) => {
        if ( 
          item &&
          this.state.recommendedCollection &&
          this.state.recommendedCollection.length > 0
        ) { 
          this.state.recommendedCollection.forEach((product) => {
            if (item.product_id == product.id) {
              totalRecommendationProductsinCart++;
            }
          });
        }
      }); 

      if (
        totalRecommendationProductsinCart > 0 &&
        totalRecommendationProductsinCart == cart.items.length
      ) {
        this.clearCart();
      } 
    }
  },
  async processAllowedGifts (cart){
    let _shopifyCart = await this.getShopifyCart();

    // console.log(_shopifyCart);
  
    if(cart && cart.items && cart.items.length > 0){
      let giftsToUpdate = {};

      this.state.allowedGifts.forEach((gift) => {
        let giftInCart = false;
        let giftVariantInCart = false;
        let giftQuantityInCart = 0;
        let giftConditionsMet = true;
        cart.items.forEach((item) => {
          
          if(item.variant_id == gift.variant_id ){
            giftVariantInCart = true;
            giftInCart=true;
            giftQuantityInCart = item.quantity;
          }
        });

        if(gift.conditions.cart_total){

          if(gift.conditions.cart_total.operator == ">="){
            if(cart.total_price < gift.conditions.cart_total.value){
              giftConditionsMet = false;
            }
          }

        }

        if(gift.conditions.cart_items){
          if(gift.conditions.cart_items.operator == ">="){
            if(cart.item_count < gift.conditions.cart_items.value){
              giftConditionsMet = false;
            }
          }
        }

        if(gift.conditions.variant_in_cart && gift.conditions.variant_in_cart.length > 0){

          gift.conditions.variant_in_cart.forEach((variant) => {
            cart.items.forEach((item) => {
              if(variant.operator == "!="){
                if(item.variant_id == variant.value){
                  giftConditionsMet = false;
                }
              }
              
            });
          });
        }
 
        if(giftConditionsMet && !giftInCart && !giftVariantInCart){
          giftsToUpdate[gift.variant_id] = gift.quantity_to_add;
        }
        else if(giftConditionsMet && giftVariantInCart && giftQuantityInCart != gift.quantity_to_add){
          giftsToUpdate[gift.variant_id] = gift.quantity_to_add; 
        } 
        else if(!giftConditionsMet && giftInCart){
          giftsToUpdate[gift.variant_id] = 0;
        }
        else if(!giftConditionsMet && giftVariantInCart){
          giftsToUpdate[gift.variant_id] = 0;
        }
          


      }); 
       
      if(giftsToUpdate && Object.keys(giftsToUpdate).length > 0){
        let itemsToUpdate = {};
        Object.keys(giftsToUpdate).forEach((key) => {

          itemsToUpdate[key]= giftsToUpdate[key];

        }); 
        this.bulktUpdateCart(itemsToUpdate);

       
      }

    }


  },
  async ProcessCartGifts() {
    // Add 0r Remove Cart Gifts based on allowedGifts
    if (this.state.cartState && this.state.cartState.length > 0) {

    let cart = this.state.cartState[0];
    await this.checkRecommendedUpsells(cart);
    await this.processAllowedGifts(cart); 
      
    }
  },
  checkCart() {
    this.ProcessCartGifts();
  },
  clearCart() {
    console.log(`Clearing Cart`); 
    axios
      .post("/cart/clear.js")
      .then((response) => {
        this.getCart(); 
      }) 
      .catch((error) => {
        console.log(error);
      });
  }

});

const slideCartState = Vue.reactive({
  hidden: true,
});

const toggleCart = {
  openCart() {
    slideCartState.hidden = !slideCartState.hidden;
    menuState.hidden = true;

    if (slideCartState.hidden) {
      document.body.classList.remove("slide-cart-open");
    } else { 
      document.body.classList.add("slide-cart-open"); 
    }

  },
  showCart() {
    slideCartState.hidden = false;
    menuState.hidden = true;
    document.body.classList.add("slide-cart-open");
    store.getCart(); 
  }, 
};

const menuState = Vue.reactive({
  hidden: true,
});

const toggleMenu = {
  openMenu() {
    menuState.hidden = !menuState.hidden;
    slideCartState.hidden = true;
  },
};

const toggleClose = {
  closeAll() {
    slideCartState.hidden = true;
    menuState.hidden = true;
    document.body.classList.remove("slide-cart-open");
  }, 
};

const freeShippingSettings = {
  freeShippingThreshold: 10000,
  freeShippingMessage: "_value_",
  remainingMessage: "_value_",
  successMessage: "🎉 You’ve earned free shipping!",
};  

if (document.querySelector("#cart-with-header")) {
  const headerCart = Vue.createApp({
    delimiters: ["${", "}"],
    data() {
      return {
        cartData: store.state.cartState,
        scrollY: 0,
        isOpeningMenu:false,
        checkoutLoading:false
      };
    },
    methods: {
      toggleSlideCart() {
        toggleCart.openCart();
      },
      toggleMenu() {

        this.isOpeningMenu = menuState.hidden;
         
        setTimeout(() => {
          toggleMenu.openMenu();
        }, 100);  
        
      },
      closeAllDrawers() {
        this.isOpeningMenu = false;
        toggleClose.closeAll();
      },
      removeItem(item) {
        item.removing = true;
        axios
          .post("/cart/change.js", {
            id: item.key,
            quantity: 0,
          })
          .then((response) => {
            store.getCart();
          })
          .catch((error) => {
            console.log(error);
            item.removing = false;
          });
      },

      decrement(item) {
        //if(store.state.updatingCart) return;
        let updateQuantity = item.quantity - 1;
        item.quantity = updateQuantity;
        const data = {
          id: item.key,
          quantity: updateQuantity,
        };

        item.loading_minus = true;
        store.setCartLoading();
        axios
          .post("/cart/change.js", data)
          .then((response) => {
            store.getCart();
          })
          .catch((error) => {
            console.log(error);
            item.loading_minus = false;
          });
      },
      increment(item) {
        //  if(store.state.updatingCart) return;
        let updateQuantity = item.quantity + 1;
        item.quantity = updateQuantity;
        const data = {
          id: item.key,
          quantity: updateQuantity,
        };
        item.loading_plus = true;
        store.setCartLoading();
        axios
          .post("/cart/change.js", data)
          .then((response) => {
            store.getCart();
          })
          .catch((error) => {
            console.log(error);
            item.loading_plus = false;
          });
      },
      money(value) {
        if (!value) return 0;
        return "€" + (value / 100).toFixed(2);
      },
      isInCart(item) {
        return (
          this.cart &&
          this.cart.items &&
          this.cart.items.find((i) => i.product_id === item.id)
        );
      },
      isAllUpsellinCart() {
        if (this.cartData.length > 0) {
          let cartItems = this.cartData[0].items;
          let upsellItems = store.state.recommendedCollection;
          let upsellInCart = 0;
          for (let i = 0; i < cartItems.length; i++) {
            for (let j = 0; j < upsellItems.length; j++) {
              if (cartItems[i].product_id == upsellItems[j].id) {
                upsellInCart++;
              }
            }
          }
          if (upsellInCart == upsellItems.length) {
            return true;
          } else {
            return false;
          }
        }
      },

      addToCart(item) {
        item.loading = true;
        store.addToCart(item.variants[0].id, 1);
        setTimeout(() => {
          item.loading = false;
        }, 2000);
      },
      UpsellAddToCart(item) {
        item.loading = true; 
        store.addToCartWithProperties({
          id: item.variants[0].id, 
          quantity: 1,
          properties: { upsell: true },
          cb: (response) => {
            item.loading = false;
          },
        });
      },
      clearCart() {
        axios
          .post("/cart/clear.js")
          .then((response) => {
            store.getCart();
          })
          .catch((error) => {
            console.log(error);
          });
      },
      selling_planName(item) {
        if (item.selling_plan_allocation) {
          return item.selling_plan_allocation.selling_plan.name;
        } else {
          return null;
        }
      },
      scrollUpdate(e) {
        this.scrollY = window.scrollY;
      },
      openCheckout() { 
            window.location.href = "/checkout";
        this.checkoutLoading=true;
      //  this.$refs.checkoutBtnText.innerHTML = 'Processing ...';
        setTimeout(() => {  
       //  this.checkoutLoading=false; 
       //  this.$refs.checkoutBtnText.innerHTML = 'Redirecting to Checkout ...';
         
        },1500);    
        setTimeout(() => {
        //  $('body').addClass('opacity-0 transition duration-500');
        }, 1500);  
        setTimeout(() => {
          this.checkoutLoading=false; 
     
        },8000);

      }
    },
    computed: {
      cartTotal() {
        if (this.cartData.length > 0) {
          return this.cartData[0].total_price;
        }
      },
      cartCount() {
        if (this.cartData.length > 0) {
          return this.cartData[0].item_count;
        }
      },
      isFreeShipping() {
        if (this.cartData.length > 0) {
          return (
            this.cartData[0].total_price >=
            freeShippingSettings.freeShippingThreshold
          );
        }
      },
      remaingShippingPercetange() {
        if (this.cartData.length > 0) {
          let percentage =
            (this.cartData[0].total_price /
              freeShippingSettings.freeShippingThreshold) *
            100;
          if (percentage > 100) {
            percentage = 100;
          }
          return percentage;
        }
      },

      awayFromFreeShipping() {
        if (this.cartData.length > 0) {
          return (
            freeShippingSettings.freeShippingThreshold -
            this.cartData[0].total_price
          );
        }
      },
      freeShippingMessage() {
        if (this.cartData.length > 0) {
          return freeShippingSettings.freeShippingMessage.replace(
            "_value_",
            this.money(freeShippingSettings.freeShippingThreshold)
          );
        }
      },

      gotFreeShippingMessage() {
        if (this.cartData.length > 0) {
          if (
            this.cartData[0].total_price >=
            freeShippingSettings.freeShippingThreshold
          ) {
            
            return freeShippingSettings.successMessage;
          } else {
            return "";
          }
        }
      },
      awayFreeShippingMessage() {
        if (this.cartData.length > 0) {
          if (
            this.cartData[0].total_price <
            freeShippingSettings.freeShippingThreshold
          ) {
            return freeShippingSettings.remainingMessage.replace(
              "_value_",
              this.money(this.awayFromFreeShipping)
            );
          } else {
            return "";
          }
        }
      },

      isvisibleCart() {
        return !slideCartState.hidden;
      },
      menuDrawer() {
        return menuState.hidden;
      },
      cart() {
        return this.cartData[0];
      },
      recommendedCollection() {
        return store.state.recommendedCollection;
      },

      disableCart() {
        return store.state.updatingCart;
      },
    },
    mounted() {
      let scrollEvent = this.scrollUpdate;
      document.addEventListener("scroll", function (e) {
        scrollEvent(e);
      });
    },
    created() {
      store.getCart();
      store.getRecommendedCollection();
    },
  }).mount("#cart-with-header");
}


$(document).on('ajaxProduct:added',function(){

  toggleCart.showCart();  
})